import React from 'react';
import '../App.css';
import { Button } from './Button';
import './herosection.css';

function HeroSection() {
  const scroller = () => {

  }
  return (
    <div id='home' className='heroThop' style={{ textAlign: 'center' }}>
      <div className='hero-container row'>
        <div style={{ textAlign: 'initial' }}>
          {window.innerWidth < 600 ? <>
            <div className=''>
              <img style={{height:'80vw',width:'80vw'}} src={require('../images/chopper.png')} alt="" />
            </div>
          </> : <></>}
          <h1 className='mobileS1' style={{ fontSize: '60px' }}>Excellence & Trust</h1>
          <h2 className='mobileS2' style={{ opacity: 0.6 }}>AVIATION SERVICES</h2><br />
          {window.innerWidth < 600 ? <div className='mobileS3'>
            Get Services from experts who have spent a tremendous
            amount of time in various airlines in Quality
            Control and various CAMO departments.<br />
          </div> : <>
            <p>Get Services from experts who have spent a tremendous </p>
            <p>amount of time in various airlines in Quality </p>
            <p>Control and various CAMO departments.</p><br />
          </>}
          <div className='hero-btns'>
            <Button
              classes='shadow herobut1'
              className='btn'
              buttonStyle='btn--outline'
              buttonSize='btn--large'
            >
              CONTACT US
            </Button>
            <Button
              classes='homebut'
              className='btn1'
              buttonStyle='btn--primary'
              buttonSize='btn--large'
              onClick={() => console.log('hey')}
            >
              KNOW MORE
            </Button>
          </div>
        </div>
        {window.innerWidth < 600 ? <>
        </> : <> <div className=''>
          <img src={require('../images/chopper.png')} alt="" />
        </div></>}
      </div>
    </div>
  );
}

export default HeroSection;
